import { render } from "./LightboxWelcomeCard.vue?vue&type=template&id=fb531c7a&scoped=true"
import script from "./LightboxWelcomeCard.vue?vue&type=script&lang=js"
export * from "./LightboxWelcomeCard.vue?vue&type=script&lang=js"

import "./LightboxWelcomeCard.vue?vue&type=style&index=0&id=fb531c7a&lang=scss&scoped=true"
import "./LightboxWelcomeCard.vue?vue&type=style&index=1&id=fb531c7a&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb531c7a"]])

export default __exports__